class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    
    if (this.classList.contains('facet-filters-form__header')) {
      const filterToggle = this.querySelector('.facet--button-toggle');
      const closeButton = document.querySelector('.filter-drawer__close');
      const applyButton = document.querySelector('.filter-apply__btn');
      const target = document.getElementById('main-collection-filters') || document.getElementById('main-search-filters');
      const toggleDrawer = () => {
        if(target){
          document.body.classList.toggle('overflow-hidden');
          document.body.classList.toggle('filter-drawer__open');
          target.classList.toggle('is-active');
        }
      };
  
      if (filterToggle) {
        filterToggle.addEventListener("click", () => {
          if (window.matchMedia("(max-width: 989px)").matches) {
            toggleDrawer();
          }
        });
      }
      if (closeButton || applyButton) {
        const closeHandler = () => {
          if (window.matchMedia("(max-width: 989px)").matches) {
            toggleDrawer();
          }
        };
        closeButton && closeButton.addEventListener("click", closeHandler);
        applyButton && applyButton.addEventListener("click", closeHandler);
      }
    }
    window.addEventListener('resize', function(event){
      if (window.matchMedia("(min-width: 990px)").matches) {
        const target = document.getElementById('main-collection-filters') || document.getElementById('main-search-filters');
        if(target){
          document.body.classList.remove('overflow-hidden');
          document.body.classList.remove('filter-drawer__open');
          target.classList.remove('is-active');
        }
      }
    });
    
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    // TS (todo 518778627): remember that the shopper triggered this render (filter tick, sort change or
    // removing an active-filter chip) so we can bring them back to the top of the results afterwards.
    // Browser back/forward calls renderPage with updateURLHash = false — leave its restored scroll alone.
    FacetFiltersForm.scrollAfterRender = updateURLHash;
    const sections = FacetFiltersForm.getSections();
    const loadingSpinners = document.querySelectorAll('.facets-container .loading__spinner, facet-filters-form .loading__spinner');
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    const enclosureRequest = !!document.querySelector('#FacetFiltersForm [data-ts-enclosure-fitment]');
    const requestedParams = FacetFiltersForm.searchParamsPrev;
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        if (enclosureRequest && requestedParams !== FacetFiltersForm.searchParamsPrev) return;
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
    
    const productGrid = document.getElementById('product-grid');
    if(productGrid){
      productGrid.classList.add('grid-animation-false');
      const checkMarquee = productGrid.querySelectorAll('.marquee3k');
      if (checkMarquee.length > 0) {
        Marquee3k.init({ selector: 'marquee3k' });
      }
    }

    // TS (todo 518778627): a filtered grid is usually much shorter than the one it replaces, so the
    // browser clamps the old scroll offset to the new (shorter) document and the shopper lands in the
    // footer. Put them back at the top of the results instead.
    if (FacetFiltersForm.scrollAfterRender) {
      FacetFiltersForm.scrollAfterRender = false;
      FacetFiltersForm.scrollToResults();
    }
  }

  static scrollToResults() {
    const anchor =
      document.querySelector('.facet-filters-form__header:not(.hidden)') ||
      document.querySelector('.facets-vertical') ||
      document.getElementById('ProductGridContainer');
    if (!anchor) return;

    const jump = () => {
      const headerHeight =
        parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 0;
      const top = anchor.getBoundingClientRect().top + window.pageYOffset - headerHeight - 12;
      window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
    };

    // On mobile the filter drawer locks the page (body.filter-drawer__open + overflow-hidden), so a
    // scroll fired now would be swallowed. Wait until the shopper closes/applies the drawer, then move.
    if (document.body.classList.contains('filter-drawer__open')) {
      if (FacetFiltersForm.drawerScrollObserver) FacetFiltersForm.drawerScrollObserver.disconnect();
      FacetFiltersForm.drawerScrollObserver = new MutationObserver(() => {
        if (!document.body.classList.contains('filter-drawer__open')) {
          FacetFiltersForm.drawerScrollObserver.disconnect();
          FacetFiltersForm.drawerScrollObserver = null;
          requestAnimationFrame(jump);
        }
      });
      FacetFiltersForm.drawerScrollObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
      return;
    }
    jump();
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    
    const priceRange = parsedHTML.querySelector('price-range');
    if (priceRange) {
      const rangeGroupSliderLabel = priceRange.querySelector('.range-group__slider-label');
      if (rangeGroupSliderLabel) {
        document.querySelector('.range-group__slider-label').innerHTML = rangeGroupSliderLabel.innerHTML;
      }
    }

    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter'
    );

    // TS (todos 520290413 / 520291399 / 520291587 / 520293041): a group that has no values in the new selection is not
    // rendered (tick Towels on Golf Accessories and SHOP BY GENDER + SHOP BY TYPE drop out), so the groups no longer line
    // up with the data-index slots the per-group update below writes into — it would paint groups into the wrong slots,
    // leave stale ones behind, or throw on a missing slot. When the set of groups changed, swap the whole list for the
    // server's render instead, keeping which groups were open, which were expanded with "show more", and the focus.
    const groupLabel = (element) => {
      const label = element.querySelector('.facets__summary-label');
      return label && label.firstChild ? label.firstChild.textContent.trim() : '';
    };
    const groupSignature = (elements) => Array.from(elements).map((element) => `${element.id}|${groupLabel(element)}`).join('~');
    const currentFacetDetailsElements = document.querySelectorAll('#FacetFiltersForm .js-filter');
    const currentWrapper = document.getElementById('FacetsWrapperDesktop');
    const nextWrapper = parsedHTML.getElementById('FacetsWrapperDesktop');
    if (currentWrapper && nextWrapper && groupSignature(currentFacetDetailsElements) !== groupSignature(facetDetailsElements)) {
      const openLabels = Array.from(currentFacetDetailsElements).filter((element) => element.open).map(groupLabel);
      const expandedLabels = Array.from(currentFacetDetailsElements)
        .filter((element) => element.querySelector('show-more-button .label-show-more.hidden'))
        .map(groupLabel);
      const eventGroup = event && event.target && event.target.closest ? event.target.closest('.js-filter') : null;
      const eventLabel = eventGroup ? groupLabel(eventGroup) : null;
      currentWrapper.innerHTML = nextWrapper.innerHTML;
      currentWrapper.querySelectorAll('.js-filter').forEach((element) => {
        const label = groupLabel(element);
        if (openLabels.includes(label)) element.open = true;
        const showMore = element.querySelector('show-more-button button');
        if (showMore && expandedLabels.includes(label)) showMore.click();
      });
      FacetFiltersForm.renderActiveFacets(parsedHTML);
      FacetFiltersForm.renderAdditionalElements(parsedHTML);
      if (eventLabel) {
        const sameGroup = Array.from(currentWrapper.querySelectorAll('.js-filter')).find((element) => groupLabel(element) === eventLabel);
        const summary = sameGroup && sameGroup.querySelector('.facets__summary');
        if (summary) summary.focus({ preventScroll: true });
      }
      return;
    }

    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newElementSelector = document
          .getElementById(closestJSFilterID)
          .classList.contains('mobile-facets__details')
          ? `#${closestJSFilterID} .mobile-facets__close-button`
          : `#${closestJSFilterID} .facets__summary`;
        const newElementToActivate = document.querySelector(newElementSelector);
        if (newElementToActivate) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
      var checkActiveLength = parseInt(activeFacetsElement.querySelectorAll('facet-remove').length);
      if(checkActiveLength > 1){
        document.querySelector('.active-facets-desktop').classList.remove('hidden');
      }else{
        document.querySelector('.active-facets-desktop').classList.add('hidden');
      }
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    if (form.querySelector('[data-ts-enclosure-fitment]')) {
      const params = new URLSearchParams();
      for (const [key, value] of formData.entries()) {
        if (key === 'filter.p.m.custom.filter_values' && value === '') continue;
        params.append(key, value);
      }
      return params.toString();
    }
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    if(this.querySelector('price-range')){
      var getPriceRange = this.querySelector('price-range').getAttribute('style');
      const numericRegex = /\d+(\.\d+)?/;
      const rangeMin = parseFloat((getComputedStyle(this.querySelector('price-range')).getPropertyValue('--filter-range-min')).match(numericRegex)[0]);
      const rangeMax = parseFloat((getComputedStyle(this.querySelector('price-range')).getPropertyValue('--filter-range-max')).match(numericRegex)[0]); 
      if(rangeMin == 0 && rangeMax == 100){
         searchParams = removeQueryParam(searchParams, "filter.v.price.gte");
         searchParams = removeQueryParam(searchParams, "filter.v.price.lte");
      }
    }
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];

      sortFilterForms.forEach((form) => {
        if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
          const noJsElements = document.querySelectorAll('.no-js-list');
          noJsElements.forEach((el) => el.remove());
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.scrollAfterRender = false;
FacetFiltersForm.drawerScrollObserver = null;
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach(element => element.addEventListener('input', this.onRangeChange.bind(this)));
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    var inputEvent = event.target.dataset.type;
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues(inputEvent);
  }

  setMinAndMaxValues(inputEvent) {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    const maxPrice = inputs[0].getAttribute('max');
    var priceGap = 1;
    var minInputPrice = parseInt(minInput.value);
    var maxInputPrice = parseInt(maxInput.value);

    if(inputEvent != 'high'){
      if(minInputPrice >= maxInputPrice){
        minInput.value = maxInputPrice - priceGap;
        minInputPrice = maxInputPrice - priceGap;
      }
    }
    if(inputEvent == 'high'){
      if(maxInputPrice <= minInputPrice){
        maxInput.value = minInputPrice + priceGap;
        maxInputPrice = minInputPrice + priceGap;
      }
    }
    
    const sliderMinimumValue = (minInputPrice / parseInt(maxPrice) * 100).toFixed(2);
    const sliderMaximumValue = (maxInputPrice / parseInt(maxPrice) * 100).toFixed(2);
    
    this.style.setProperty("--filter-range-min", sliderMinimumValue+'%');
    this.style.setProperty("--filter-range-max", sliderMaximumValue+'%');

  }

  adjustToValidValues(input) {
    return false;
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

function removeQueryParam(url, paramKey) {
  const urlSearchParams = new URLSearchParams(url);
  urlSearchParams.delete(paramKey);
  return urlSearchParams.toString();
}
